/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    ClosedCaptionTypes,
    DownloadableMediaTypes,
    IAudioBinaryReference,
    ICCFile,
    IDownloadableFile,
    IPlayerData,
    IPlayerOptions,
    IPlayerResources,
    IVideoBinaryReference,
    IVideoClosedCaptionBinaryReference,
    IVideoFile,
    IVideoMetadata,
    IVideoTranscriptBinaryReference,
    MediaQuality,
    MediaTypes,
    Player
} from '@msdyn365-commerce-modules/video-player-utilities';

import Carousel from './carousel/Carousel';
import { ICarouselProps } from './carousel/Carousel.props';
import { CartIconComponent } from './cart-icon/cart-icon.component';
import { IPromoCodeProps, PromoCodeComponent } from './promocode/promocode.component';
import { RatingComponent } from './rating/rating.component';
import { SocialMedia, SocialMediaComponent } from './social-media/social-media.components';

export * from './action-menu';
export * from './add-to-cart';
export * from './add-to-wishlist/add-to-wishlist.component';
export * from './cartline';
export * from './order-template';
export * from './price';
export * from './product-card';
export * from './product-card-v2';
export * from './product-dimension';
export * from './product-dimensions-matrix';
export * from './refiner';
export * from './search-bar';
export * from './table';
export * from './wishlist-icon/wishlist-icon.component';

/**
 * Exporting types.
 */
export {
    Carousel,
    CartIconComponent,
    ClosedCaptionTypes,
    DownloadableMediaTypes,
    IAudioBinaryReference,
    ICarouselProps,
    ICCFile,
    IDownloadableFile,
    IPlayerData,
    IPlayerOptions,
    IPlayerResources,
    IPromoCodeProps,
    IVideoBinaryReference,
    IVideoClosedCaptionBinaryReference,
    IVideoFile,
    IVideoMetadata,
    IVideoTranscriptBinaryReference,
    MediaQuality,
    MediaTypes,
    Player,
    PromoCodeComponent,
    RatingComponent,
    SocialMedia,
    SocialMediaComponent
};
